<template lang="pug">
  .card-payment(v-if="cardPayment")
    .card-payment__border.card-payment__border--top
    .card-payment__border.card-payment__border--right
    .card-payment__border.card-payment__border--bottom
    .card-payment__border.card-payment__border--left
    .card-payment__corner.card-payment__corner--tl
    .card-payment__corner.card-payment__corner--tr
    .card-payment__corner.card-payment__corner--bl
    .card-payment__corner.card-payment__corner--br
    .card-payment__decor-top
    .card-payment__decor-bottom
    .card-payment__title(v-if="h1") {{h1}}
    .card-payment__content
      h3.card-payment__title(v-if='cardPayment.subtitle1') {{ cardPayment.subtitle1 }}
      .card-payment__text(v-if='cardPayment.text1' v-html="cardPayment.text1")
      ul.card-payment__cards(v-if='cardPayment.cardList')
        li.card-payment__cards-item(v-for="(item, index) in cardPayment.cardList" :key="index") {{ item.cardName }}
      h4.card-payment__subtitle(v-if='cardPayment.headline1') {{ cardPayment.headline1 }}
      .card-payment__text(v-if='cardPayment.text2' v-html="cardPayment.text2")
      h4.card-payment__subtitle(v-if='cardPayment.headline2') {{ cardPayment.headline2 }}
      .card-payment__text(v-if='cardPayment.text3' v-html="cardPayment.text3")
      h4.card-payment__subtitle(v-if='cardPayment.headline3')  {{ cardPayment.headline3 }}
      .card-payment__text(v-if='cardPayment.text4' v-html="cardPayment.text4")
      h3.card-payment__title(v-if='cardPayment.subtitle2')  {{ cardPayment.subtitle2 }}
      .card-payment__text(v-if='cardPayment.text5' v-html="cardPayment.text5")
      h3.card-payment__title(v-if='cardPayment.headline3')  {{ cardPayment.subtitle3 }}
      .card-payment__text(v-if='cardPayment.text6' v-html="cardPayment.text6")
      h4.card-payment__subtitle(v-if='cardPayment.headline4')  {{ cardPayment.headline4 }}
      h4.card-payment__subtitle(v-if='cardPayment.headline5')  {{ cardPayment.headline5 }}
      img.card-payment__img-card(v-if='cardPayment.visaCards.path' :src="cardPayment.visaCards.path" :alt="cardPayment.visaCards.name")
      .card-payment__text(v-if='cardPayment.text7' v-html="cardPayment.text7")
      h4.card-payment__subtitle(v-if='cardPayment.headline6') {{ cardPayment.headline6 }}
      .card-payment__text(v-if='cardPayment.text8' v-html="cardPayment.text8")
      img.card-payment__img-card(v-if='cardPayment.masterCards.path' :src="cardPayment.masterCards.path" :alt="cardPayment.masterCards.name")
      h4.card-payment__subtitle(v-if='cardPayment.headline7') {{ cardPayment.headline7}}
      ol.card-payment__list(v-if='cardPayment.textList')
        li.card-payment__list-item(v-for="(item, index) in cardPayment.textList" :key="index") {{ item.text }}
      img.card-payment__card(v-if='cardPayment.cardImage.path' :src="cardPayment.cardImage.path" :alt="cardPayment.cardImage.name")
      .card-payment__text(v-if='cardPayment.text9' v-html="cardPayment.text9")
      h3.card-payment__title(v-if='cardPayment.sibtitle4') {{ cardPayment.subtitle4 }}
      img.card-payment__logo-bank(v-if='cardPayment.bankLogo.path' :src="cardPayment.bankLogo.path" :alt="cardPayment.bankLogo.name")
      .card-payment__text(v-if='cardPayment.text10' v-html="cardPayment.text10")
      h3.card-payment__title(v-if='cardPayment.sibtitle5') {{ cardPayment.subtitle5 }}
      h4.card-payment__subtitle(v-if='cardPayment.headline8') {{ cardPayment.headline8}}
      .card-payment__text(v-if='cardPayment.text11' v-html="cardPayment.text11")
      .card-payment__block(v-if='cardPayment.verifiedCards')
        img.card-payment__block-image(v-for="item in cardPayment.verifiedCards" :src="item.path" :alt="item.name")
      .card-payment__text(v-if='cardPayment.text12' v-html="cardPayment.text12")
      h4.card-payment__subtitle(v-if='cardPayment.headline9') {{ cardPayment.headline9}}
      .card-payment__text(v-if='cardPayment.text13' v-html="cardPayment.text13")
</template>

<script>
import EventBus from '@/eventBus';

//import '@/components/сardPayment/сardPayment.styl';
import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';

export default {
  name: 'CardPayment',

  mixins: [AjaxHelpersVue],

  data() {
    return {
      cardPayment: null,
      ps: null
    }
  },

  components: {},

  created() {
    // Загрузка данных для страницы
    EventBus.$on('loadCardPaymentPage', params => {
      this.request(params.url);
    });
  },

  methods: {
    request(url) {
      this.req('CardPaymentPage:getCardPaymentPage', {url}, res => {
        if(this.checkProperty(res.content)) {
          this.cardPayment = res.content;

          this.$nextTick(() => {
            this.initScroll();
          });
        }
      }, 'card-payment');
    },

    initScroll() {
      if(this.ps === null) {
        this.ps = new PerfectScrollbar('.card-payment__content', {
          wheelSpeed: 0.3,
          wheelPropagation: true,
          minScrollbarLength: 25,
          maxScrollbarLength: 25
        });
      }
      else {
        this.ps.update();
      }
    },
  }
}
</script>
